import { useEffect } from 'react';
import { useEffectOnce } from 'react-use';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useAuth } from '@zep/auth';
import { logger } from '@zep/core-logger';
import { Explore } from '../../../components/service/home/Explore';
export const TutorialPageView = () => {
  const router = useRouter();
  const {
    user
  } = useAuth();
  useEffectOnce(() => {
    logger.track('enter_explore');
  });
  useEffect(() => {
    if (user?.isEdu) {
      router.replace('/home/explore/edu');
    }
  }, [router, user]);
  return <>
      <Explore data-sentry-element="Explore" data-sentry-source-file="tutorial.tsx" />
      <Script src="https://www.youtube.com/iframe_api" data-sentry-element="Script" data-sentry-source-file="tutorial.tsx" />
    </>;
};